// Helpers para identificar módulos de Síntesis y FCT y aplicar tramo por defecto.
// El front decide el tramo (T1 = septiembre, T2 = febrero) cuando el backend
// no lo trae. Solo Síntesis/FCT son editables; el resto mantiene lo del backend.

const normaliza = (txt) => (txt || '').toString().toLowerCase();

export const isFCT = (item) => {
  const desc = normaliza(item?.descripcion);
  return (
    desc.includes('formación en el centro de trabajo') ||
    desc.includes('formación en centros de trabajo') ||
    desc.includes('formacion en el centro de trabajo') ||
    desc.includes('formacion en centros de trabajo')
  );
};

export const isSintesis = (item) => {
  const desc = normaliza(item?.descripcion);
  const nom = normaliza(item?.nombre || item?.nombreModulo);
  return desc.includes('síntesis') || desc.includes('sintesis')
    || nom.includes('síntesis') || nom.includes('sintesis');
};

export const isSintesisOFCT = (item) => isFCT(item) || isSintesis(item);

export const inicioPorTramo = (tramo) => (
  (tramo || '').toUpperCase() === 'T2' ? 'febrero' : 'septiembre'
);

export const withDefaultTramo = (items) => (items || []).map((item) => {
  if (!isSintesisOFCT(item)) return item;
  const tramo = (item.tramo || '').toUpperCase();
  // Si ya trae tramo editable, el tramo manda: reconciliamos el Inicio con él
  // para que un T2 con un Inicio heredado del backend no se quede en septiembre.
  if (tramo === 'T1' || tramo === 'T2') return { ...item, Inicio: inicioPorTramo(tramo) };
  return { ...item, tramo: 'T1', Inicio: item.Inicio || 'septiembre' };
});

// Variante para el shape agrupado del wizard: { moduleKey: [...items] }
export const withDefaultTramoGrouped = (grouped) => {
  const result = {};
  Object.entries(grouped || {}).forEach(([k, arr]) => {
    result[k] = withDefaultTramo(arr);
  });
  return result;
};

// ¿Están seleccionados TODOS los módulos del año en curso (por defecto PRIMERO)?
// Las líneas de 2º año (interno) no cuentan para decidir matrícula completa vs
// parcial. `activity` es el shape agrupado del wizard { key: [items] }; `modulos`
// la lista de seleccionados en formato "modulo descripcion". Sin módulos del año
// devuelve true (no hay nada que falte).
export const todosModulosAnioSeleccionados = (activity, modulos, anio = 'PRIMERO') => {
  const delAnio = Object.values(activity || {})
    .flat()
    .filter((c) => c && c.curso === anio)
    .map((c) => `${c.modulo} ${c.descripcion}`);
  if (delAnio.length === 0) return true;
  return delAnio.every((m) => (modulos || []).includes(m));
};

// Precio de inscripción según la selección: matrícula completa (todos los módulos
// del año en curso seleccionados) usa `precio`; una selección parcial usa
// `importe_suelto`. Aplica el % de descuento (si lo hay) sobre la base elegida.
// `dp` es la respuesta de buscarPreciosCiclo (array -> primera fila) o esa fila.
export const precioInscripcionSegunSeleccion = (dp, completo) => {
  const fila = Array.isArray(dp) ? dp[0] : dp;
  if (!fila) return 0;
  const base = completo ? Number(fila.precio) : Number(fila.importe_suelto);
  const b = Number.isFinite(base) ? base : 0;
  const desc = Number(fila.porcentaje_descuento) || 0;
  return b - (b * desc) / 100;
};
